import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, Image, Badge, Button } from 'react-bootstrap';
import { logo } from '../../assets/Assets';
import { useUser } from '../../context/UserContext';
import { useCart } from '../../context/CartContext';
import { PROFILE_ROOT_ID, PROFILE_ADMIN_ID } from '../../Consts';
import { uSubscriptionName, uSubscriptionExpiration, uSearchesRemaining } from '../../utils';

const Menu = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const { cart } = useCart();

  const [userPlanDeadline, setUserPlanDeadline] = useState('-');
  const [userPlanName, setUserPlanName] = useState('-');
  const [userSearchesRemaining, setUserSearchesRemaining] = useState(null);
  const cartItems = cart ? cart : [];

  useEffect(() => {
    if (user) {
      setUserPlanName(uSubscriptionName(user.subscription));
      setUserPlanDeadline(uSubscriptionExpiration(user.releasedDeadline));
      setUserSearchesRemaining(uSearchesRemaining(user.searches));
    }
  }, [user]);


  const handleContract = () => {
    navigate('/main/plans');
  };

  return (
    <Navbar expand="lg">
      <Container>
        {/* Logo */}
        <Navbar.Brand href="/main" className="d-flex align-items-center">
          <Image src={logo} rounded alt="Logo" height="60" className="me-2" />
        </Navbar.Brand>

        {/* Links */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/main">PÁGINA INICIAL</Nav.Link>
            <Nav.Link href="/main/search">PESQUISAR</Nav.Link>
            <Nav.Link href="/main/bases">BASES DE DADOS</Nav.Link>
          </Nav>

          {/* Right Buttons */}
          <div className="navbar-nav">
            {user && user.subscription === 0 && (
              <div className='text-center'>
                <Badge bg="danger" className="me-2 text-start">
                  Plano: {userPlanName}<br />
                  Vencimento: {userPlanDeadline}<br />
                  Pesquisas: {userSearchesRemaining} de 5
                </Badge>
              </div>
            )}
            {userSearchesRemaining === 0 && <><Button size="sm" variant="success" onClick={handleContract}><b>CONTRATAR</b></Button></>}
            {user && (user.profile === PROFILE_ROOT_ID || user.profile === PROFILE_ADMIN_ID) && <Nav.Link href="/main/settings">CONFIGURAÇÕES</Nav.Link>}
            <Nav.Link href="/main/cart">
              <div className="position-relative">
                <i className="bi bi-file-earmark-spreadsheet"></i>
                {cartItems.length > 0 && (
                  <Badge bg="success" className="position-absolute top-0 start-100 translate-middle">
                    {cartItems.length}
                  </Badge>
                )}
              </div>
            </Nav.Link>
            <Nav.Link href="/main/my-profile">MEU PERFIL</Nav.Link>
            <Nav.Link href="/main/logout">SAIR</Nav.Link>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Menu;
